module.exports = __webpack_public_path__ + "images/icons/psp/look1.svg";